// When users have less than 500mb of free space we show a message warning them
export const STORAGE_CAPACITY_LOW_THRESHOLD = 524288000;
export const DEFAULT_THUMB_SIZE = 72;
